import React, { useMemo } from 'react';
import TableContainer from 'Common/TableContainer';


interface Props {
    manager: any[];
    account: any[];
    sales: any[];
    transaction: any[]
}

const VendorDetails: React.FC<Props> = ({ sales }) => { 
 
    const columns = useMemo(() => [
        {
            header: "#",
            accessorFn: (_: any, index: number) => index + 1,
            enableColumnFilter: false,
        },
        {
            header: "Vendor Name",
            accessorKey: "vendorName",
            enableColumnFilter: false,
        },
        {
            header: "Spotrate",
            accessorFn: (row: any) => row.spotrate ?? 0,
            enableColumnFilter: false,
        },
      
        {
            header: "Purity",
            accessorFn: (row: any) => row.purity ?? 0,
            enableColumnFilter: false,
        },
        {
            header: "Weigth",
            accessorFn: (row: any) => row.weigth ?? 0,
            enableColumnFilter: false,
        },
        {
            header: "Deal",
            accessorFn: (row: any) => row.deal ?? 0,
            enableColumnFilter: false,
        }, 
          {
            header: "Amount",
            accessorKey: "amount",
            enableColumnFilter: false,
        },
    ], [sales]);




    return (
        <div className=" col-span-9 col-start-4 ">
            <div className=" col-span-9 card">
                <div className="card-body ">
                    <div className="grid items-center grid-cols-9 gap-3    ">
                        <div className=" col-span-5  ">
                            <h6 className="text-15">Deals </h6>
                        </div>
                        <div className=" col-span-1 col-start-10  mb-2  ">
                            <button type="button" className="btn bg-custom-500 text-white">
                                <i className="ri-download-2-line pr-1"></i> Export
                            </button>
                        </div>
                    </div>
                    <TableContainer 
                        isPagination={true}
                        columns={columns}
                        data={sales}
                        customPageSize={7} 
                        divclassName="overflow-x-auto"
                        tableclassName="w-full whitespace-nowrap"
                        theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
                        thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
                        tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
                        PaginationClassName="flex flex-col items-end mt-5 md:flex-row"
                    />
                </div>
            </div>
        </div>
    );
};

export default VendorDetails;

